import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn';
import React from 'react';
import { Tooltip, IconButton, makeStyles, Link } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  myClassName: {
    color: theme.palette.primary.main,
    position: 'relative',
    '&:hover': {
      color: 'white'
    }
  },
  iconButton: {
    [theme.breakpoints.down(990)]: {
      marginRight: '10px',
      '& span span svg': {
        fontSize: '1.3rem'
      }
    },
    color: theme.palette.primary.main,
    position: 'relative',
    '&:hover': {
      color: 'white'
    }
  }
}));

const SignerLink = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const isInSigner = history.location.pathname.includes('signer');

  const classes = useStyles();

  return (
    <div>
      <Tooltip className='lang-changeLang' title={isInSigner ? t('signerPlace:goBackUruk') : t('signerPlace:goToSigner')}>
        <Link href={isInSigner ? '/' : '/signer'}>
          <IconButton
            aria-controls='simple-menu'
            aria-haspopup='true'
            className={classes.iconButton}
          >
            <AssignmentReturnIcon style={{
              transform: isInSigner ? 'none' : 'scaleX(-1)'
            }} fontSize='large' />

          </IconButton>
        </Link>
      </Tooltip>
    </div>
  );
};

export default withRouter(SignerLink);
